function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.308,
    height: 24,
    viewBox: "0 0 20.308 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m18.462 3.6923h-1.8462v-1.8462c0-1.0154-0.83077-1.8462-1.8462-1.8462h-12.923c-1.0154 0-1.8462 0.83077-1.8462 1.8462v16.615c0 1.0154 0.83077 1.8462 1.8462 1.8462h1.8462v1.8462c0 1.0154 0.83077 1.8462 1.8462 1.8462h12.923c1.0154 0 1.8462-0.83077 1.8462-1.8462v-16.615c0-1.0154-0.83077-1.8462-1.8462-1.8462zm-14.769 1.8462v12.923h-1.8462v-16.615h12.923v1.8462h-9.2308c-1.0154 0-1.8462 0.83077-1.8462 1.8462zm14.769 16.615h-12.923v-16.615h12.923z",
    style: {
      strokeWidth: 0.46154
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.a3f4593539c80bc0b2b58aff0760e428.svg";
export { ForwardRef as ReactComponent };